export interface IStylingAndTranslationHooks {
  classes: any;
  translation: any;
}

export enum ComponentFileProcessingState {
  SUCCESS = 'SUCCESS',
  IDLE = 'IDLE',
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING'
}
